/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown> }} Profile_Editors_Split_Offer_TitleInputs */

const en_us2_profile_editors_split_offer_title = /** @type {(inputs: Profile_Editors_Split_Offer_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your current plan is ${i?.current}`)
};

const pt_br2_profile_editors_split_offer_title = /** @type {(inputs: Profile_Editors_Split_Offer_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seu plano atual é ${i?.current}`)
};

const es_419_profile_editors_split_offer_title = /** @type {(inputs: Profile_Editors_Split_Offer_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu plan actual es ${i?.current}`)
};

const pt_pt2_profile_editors_split_offer_title = /** @type {(inputs: Profile_Editors_Split_Offer_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O teu plano atual é ${i?.current}`)
};

const fr_fr2_profile_editors_split_offer_title = /** @type {(inputs: Profile_Editors_Split_Offer_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ton programme actuel est en ${i?.current}`)
};

const de_de2_profile_editors_split_offer_title = /** @type {(inputs: Profile_Editors_Split_Offer_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dein aktueller Plan ist ${i?.current}`)
};

const it_it2_profile_editors_split_offer_title = /** @type {(inputs: Profile_Editors_Split_Offer_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La tua scheda attuale è ${i?.current}`)
};

/**
* | output |
* | --- |
* | "Your current plan is {current}" |
*
* @param {Profile_Editors_Split_Offer_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_split_offer_title = /** @type {((inputs: Profile_Editors_Split_Offer_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Split_Offer_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_split_offer_title(inputs)
	if (locale === "es-419") return es_419_profile_editors_split_offer_title(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_split_offer_title(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_split_offer_title(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_split_offer_title(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_split_offer_title(inputs)
	return en_us2_profile_editors_split_offer_title(inputs)
});
export { profile_editors_split_offer_title as "profile-editors.split_offer_title" }